import { Instance, types } from "mobx-state-tree";
import { ModalNotification } from "../../components/data-components/modal/ModalNotification";
import { globalModule } from "../service-provider/GlobalModule";
import { registerGlobalService } from "../service-provider/ServiceRegistry";

export const ModalNotificationsServiceModel = types
  .model({
    modalNotification: types.optional(types.frozen<ModalNotification>(), new ModalNotification()),
  })
  .actions((self) => {
    const createModalNotification = (
      titleKey: string,
      messageKey?: string,
      element?: any
    ) => {
      return new ModalNotification({
        titleKey,
        messageKey: messageKey ?? "",
        identifier: Date.now().toString(),
        element,
      });
    };

    return {
      closeModalNotification: () => {
        self.modalNotification = new ModalNotification();
      },

      showError({
        titleKey,
        messageKey,
        errorElement,
      }: {
        titleKey: string;
        messageKey?: string;
        errorElement?: any;
      }) {
        const modalNotification = createModalNotification(titleKey, messageKey, errorElement);
        self.modalNotification = modalNotification;
      },
    };
  });

export type ModalNotificationsService = Instance<typeof ModalNotificationsServiceModel>;
export const modalNotificationsService = ModalNotificationsServiceModel.create();
globalModule.modalNotificationsService = modalNotificationsService;
export default registerGlobalService(modalNotificationsService as ModalNotificationsService);
